import { ReceivingPersonRoleActionTypes, RolesActions } from '../actions/roles.actions';
import {
  ReceivingPersonTelephoneCodeActionTypes,
  TelephoneCodeActions,
} from '../actions/telephone.actions';
import { ContactPersonRole } from '../models/contact-person-role.model';
import { Countries } from '../effects/new-receiving-person.effects';

export interface NewReceivingPersonState {
  loadingRoles: boolean;
  loadingCountries: boolean;
  roles: ContactPersonRole[];
  countries: Countries[];
}

export const initialState: NewReceivingPersonState = {
  loadingRoles: false,
  loadingCountries: false,
  roles: [],
  countries: [],
};

export function reducer(state = initialState, action: RolesActions | TelephoneCodeActions): NewReceivingPersonState {
  switch (action.type) {
    case ReceivingPersonRoleActionTypes.LOAD_ROLES: {
      return {
        ...state,
        loadingRoles: true,
      } as NewReceivingPersonState;
    }
    case ReceivingPersonRoleActionTypes.LOAD_ROLES_COMPLETE: {
      return {
        ...state,
        loadingRoles: false,
        roles: action.payload,
      } as NewReceivingPersonState;
    }
    case ReceivingPersonRoleActionTypes.LOAD_FAIL_ROLES: {
      return {
        ...state,
        loadingRoles: false,
        roles: [],
      } as NewReceivingPersonState;
    }
    case ReceivingPersonTelephoneCodeActionTypes.LOAD_TELEPHONE_CODE: {
      return {
        ...state,
        loadingCountries: true,
      } as NewReceivingPersonState;
    }
    case ReceivingPersonTelephoneCodeActionTypes.LOAD_TELEPHONE_CODE_COMPLETE: {
      return {
        ...state,
        loadingCountries: false,
        countries: action.payload,
      } as NewReceivingPersonState;
    }
    case ReceivingPersonTelephoneCodeActionTypes.LOAD_FAIL_TELEPHONE_CODE: {
      return {
        ...state,
        loadingCountries: false,
        countries: [],
      } as NewReceivingPersonState;
    }
    default: {
      return state;
    }
  }
}
